<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspFilteringUpdateForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspFilteringUpdateForm from '@/components/organisms/master/form/InspFilteringUpdateForm'

export default {
  name: 'InspFilteringUpdatePage',

  components: {
    InspFilteringUpdateForm,
  },
}
</script>
